import { authenticationSlice, coreApi } from '@cp/shared/api/core';
import { ClientLoginResponse } from '@common/model/client/auth/login';
import { ClientAuthResponse } from '@common/model/client/auth/auth';
import { ClientRegistrationMetaParams, ClientRegistrationResponse } from '@common/model/client/registration/registration';
import { sleep } from '@cp/utils/sleep';
import { generateApiUrl } from '@common/api/configure';
import { ApiRoute } from '@common/api/route';
import { apiRouteMethodDict } from '@common/api/routeMethod';
import { ApiRouteBody } from '@common/api/routeBody';
import { OAuthRespone } from '@common/model/client/oauth/oauth';
import { ClientAuthApiTagTypes, ClientAuthApiTags } from './tags';

export const coreClientAuthApi = coreApi.enhanceEndpoints({ addTagTypes: ClientAuthApiTagTypes }).injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<ClientLoginResponse, ApiRouteBody[ApiRoute.ClientLogin]>({
      query: (body) => ({
        method: apiRouteMethodDict[ApiRoute.ClientLogin],
        url: generateApiUrl(ApiRoute.ClientLogin),
        body,
      }),
    }),

    auth: builder.mutation<ClientAuthResponse, ApiRouteBody[ApiRoute.ClientAuth]>({
      query: (body) => ({
        method: apiRouteMethodDict[ApiRoute.ClientAuth],
        url: generateApiUrl(ApiRoute.ClientAuth),
        body,
      }),
    }),

    registration: builder.mutation<ClientRegistrationResponse, ApiRouteBody[ApiRoute.ClientRegistration] & ClientRegistrationMetaParams>({
      query: ({ deviceId, platform, ...body }) => ({
        method: apiRouteMethodDict[ApiRoute.ClientRegistration],
        url: generateApiUrl(ApiRoute.ClientRegistration),
        params: { deviceId, platform },
        body,
      }),
      invalidatesTags: () => [ClientAuthApiTags.Registration],
    }),

    logout: builder.mutation<boolean, void>({
      query: () => ({
        method: 'DELETE',
        url: 'client/auth',
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          await sleep(0);
          // ToDo: clear only client dependent caches
          dispatch(coreClientAuthApi.util.resetApiState()); //  .invalidateTags(coreServiceClientDependentTags)
          dispatch(authenticationSlice.actions.setToken(null));
        } catch {}
      },
    }),

    googleAuth: builder.mutation<OAuthRespone, ApiRouteBody[ApiRoute.ClientGoogleAuth]>({
      query: (body) => ({
        method: apiRouteMethodDict[ApiRoute.ClientGoogleAuth],
        url: generateApiUrl(ApiRoute.ClientGoogleAuth),
        body,
      }),
    }),

    appleAuth: builder.mutation<OAuthRespone, ApiRouteBody[ApiRoute.ClientAppleAuth]>({
      query: (body) => ({
        method: apiRouteMethodDict[ApiRoute.ClientAppleAuth],
        url: generateApiUrl(ApiRoute.ClientAppleAuth),
        body,
      }),
    }),

    telegramAuth: builder.mutation<OAuthRespone, ApiRouteBody[ApiRoute.ClientTelegramAuth]>({
      query: (body) => ({
        method: apiRouteMethodDict[ApiRoute.ClientTelegramAuth],
        url: generateApiUrl(ApiRoute.ClientTelegramAuth),
        body,
      }),
    }),
  }),
});
